import { PIX, CREDIT_CARD, BOLETO, DIRECT, PAGSEGURO, MERCADO_PAGO } from "../constants";

export const mockEnabledMethods = [
    PIX,
    CREDIT_CARD,
    BOLETO,
    DIRECT,
    PAGSEGURO,
    MERCADO_PAGO
]